import angular from 'angular'
import './channel_hero_banners.service'
import './edit/edit.controller'

angular
  .module('admin.channel_hero_banners', [
    'admin.channel_hero_banners.service',
    'admin.channel_hero_banners.edit',
  ])
  .controller('ChannelHeroBannersCtrl', ChannelHeroBannersCtrl)

/** @ngInject */
function ChannelHeroBannersCtrl($state, $scope, $timeout, ChannelHeroBannerService) {
  var vm = this
  vm.items = []

  vm.perPage = 25
  vm.sortType = 'ts-desc'
  vm.sortReverse = false
  vm.sortType2 = 'n-asc'
  vm.sortReverse2 = false
  vm.sortType3 = 'ts-end-desc'
  vm.sortReverse3 = false

  vm.searchDraft = ''
  vm.searchPublished = ''
  vm.searchExpired = ''

  function reloadPaginationDraft() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationPublish() {
    vm.totalItems2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationArchived() {
    vm.totalItems3 = 0
    vm.oldPage3 = 0
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  reloadPaginationDraft()
  reloadPaginationPublish()
  reloadPaginationArchived()
  loadPublished(1)
  loadUnpublished(1)
  loadArchived(1)

  var tab = localStorage.getItem('channel_hero_banners')
  if (tab !== null) {
    if (tab === 'draft') {
      $('#published').removeClass('active')
      $('#archived').removeClass('active')
      $('#draft').addClass('active')
      $('#drafttab').addClass('active')
    } else if (tab === 'published') {
      $('#draft').removeClass('active')
      $('#archived').removeClass('active')
      $('#published').addClass('active')
      $('#publishedtab').addClass('active')
    } else if (tab === 'expired') {
      $('#draft').removeClass('active')
      $('#published').removeClass('active')
      $('#expired').addClass('active')
      $('#expiredtab').addClass('active')
    }
  } else {
    $('#draft').addClass('active')
    $('#drafttab').addClass('active')
  }

  vm.tabDraft = function () {
    $('#published').removeClass('active')
    $('#expired').removeClass('active')
    $('#draft').addClass('active')
    localStorage.setItem('channel_hero_banners', 'draft')
  }

  vm.tabPublished = function () {
    $('#draft').removeClass('active')
    $('#expired').removeClass('active')
    $('#published').addClass('active')
    localStorage.setItem('channel_hero_banners', 'published')
  }

  vm.tabExpired = function () {
    $('#draft').removeClass('active')
    $('#published').removeClass('active')
    $('#expired').addClass('active')
    localStorage.setItem('channel_hero_banners', 'expired')
  }

  var oldSortType, oldSortType2, oldSortType3
  function loadUnpublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    ChannelHeroBannerService.listUnpublish(vm.oldPage, 25, vm.sortType, vm.searchDraft).then(
      function (result) {
        var rewards = result.results
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        for (var i = 0; i < rewards.length; i++) {
          if (rewards[i]['ts-p'] !== undefined) {
            rewards[i].isPub = true
          } else {
            rewards[i].isPub = false
          }
          if (pageNumber === 1 && i === 0) {
            rewards[i].firstRow = true
          }

          if (rewards.length - 1 === i && rewards.length < vm.currentPage) {
            rewards[i].lastRow = true
          }
        }
        vm.sortType = oldSortType
        vm.itemsDraft = rewards
      },
    )
  }

  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    oldSortType2 = angular.copy(vm.sortType2)
    ChannelHeroBannerService.listPublish(vm.oldPage2, 25, vm.sortType2, vm.searchPublished).then(
      function (result) {
        var rewards = result.results
        if (vm.totalItems2 === 0) {
          vm.totalItems2 = result.ct
        }
        for (var i = 0; i < rewards.length; i++) {
          if (rewards[i]['ts-p']) {
            rewards[i].isPub = true
          } else {
            rewards[i].isPub = false
          }
          if (pageNumber === 1 && i === 0) {
            rewards[i].firstRow = true
          }

          if (rewards.length - 1 === i && rewards.length < vm.currentPage) {
            rewards[i].lastRow = true
          }
        }
        vm.sortType2 = oldSortType2
        vm.itemsPublish = rewards
      },
    )
  }

  function loadArchived(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage3 - 25
    } else {
      vm.first3 = false
    }

    oldSortType3 = angular.copy(vm.sortType3)
    ChannelHeroBannerService.listArchived(vm.oldPage3, 25, vm.sortType3, vm.searchExpired).then(
      function (result) {
        var rewards = result.results
        if (vm.totalItems3 === 0) {
          vm.totalItems3 = result.ct
        }
        for (var i = 0; i < rewards.length; i++) {
          if (rewards[i]['ts-p']) {
            rewards[i].isPub = true
          } else {
            rewards[i].isPub = false
          }
          if (pageNumber === 1 && i === 0) {
            rewards[i].firstRow = true
          }

          if (rewards.length - 1 === i && rewards.length < vm.currentPage) {
            rewards[i].lastRow = true
          }
        }
        vm.sortType3 = oldSortType3
        vm.itemsArchived = rewards
      },
    )
  }

  vm.pageChanged = function (newPage) {
    vm.sortType = oldSortType
    loadUnpublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged2 = function (newPage) {
    vm.sortType2 = oldSortType2
    loadPublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged3 = function (newPage) {
    vm.sortType3 = oldSortType3
    loadArchived(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.add = function () {
    $state.go('admin.channel_hero_banners.edit', { id: 0 })
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ChannelHeroBannerService.remove(item.id).then(
            function () {
              $state.reload()
            },
            function () {
              $timeout(function () {
                swal("You can't delete because has things associated with it", '', 'error')
              }, 750)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.publish = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ChannelHeroBannerService.publish(item.id).then(function () {
            $state.reload()
          })
        }
      },
    )
  }

  vm.unpublish = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ChannelHeroBannerService.unpublish(item.id).then(function () {
            $state.reload()
          })
        }
      },
    )
  }

  vm.back = function () {
    loadUnpublished(1)
    loadPublished(1)
    loadArchived(1)
  }

  vm.arrowUp = function (item) {
    if (item.edit) {
      return
    }
    var copy = angular.copy(item)
    copy.n = copy.n - 1
    ChannelHeroBannerService.update(item.id, {
      n: copy.n,
    }).then(function () {
      vm.sortType = 'ts-desc'
      vm.sortReverse = false
      vm.sortType2 = 'n-asc'
      vm.sortReverse2 = false
      vm.sortType3 = 'ts-end-desc'
      vm.sortReverse3 = false
      loadUnpublished(vm.pagination.current)
      loadPublished(vm.pagination2.current)
      loadArchived(vm.pagination3.current)
    })
  }

  vm.arrowDown = function (item) {
    if (item.edit) {
      return
    }
    var copy = angular.copy(item)
    copy.n = copy.n + 1
    ChannelHeroBannerService.update(item.id, {
      n: copy.n,
    }).then(function () {
      vm.sortType = 'ts-desc'
      vm.sortReverse = false
      vm.sortType2 = 'n-asc'
      vm.sortReverse2 = false
      vm.sortType3 = 'ts-end-desc'
      vm.sortReverse3 = false
      loadUnpublished(vm.pagination.current)
      loadPublished(vm.pagination2.current)
      loadArchived(vm.pagination3.current)
    })
  }

  vm.sort = function (type, isTab) {
    if (isTab === 1) {
      vm.sortReverse = !vm.sortReverse
      if (vm.sortReverse) {
        vm.sortType = type + '-asc'
      } else {
        vm.sortType = type + '-desc'
      }
      loadUnpublished(vm.pagination.current)
    } else if (isTab === 2) {
      vm.sortReverse2 = !vm.sortReverse2
      if (vm.sortReverse2) {
        vm.sortType2 = type + '-asc'
      } else {
        vm.sortType2 = type + '-desc'
      }
      loadPublished(vm.pagination2.current)
    } else if (isTab === 3) {
      vm.sortReverse3 = !vm.sortReverse3
      if (vm.sortReverse3) {
        vm.sortType3 = type + '-asc'
      } else {
        vm.sortType3 = type + '-desc'
      }
      loadArchived(vm.pagination3.current)
    }
  }

  var watch = $scope.$watch('vm.searchDraft', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        reloadPaginationDraft()
        loadUnpublished(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.searchDraft.length < 2) {
      return
    }

    reloadPaginationDraft()
    loadUnpublished(1)
  })

  var watch1 = $scope.$watch('vm.searchPublished', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        reloadPaginationPublish()
        loadPublished(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.searchPublished.length < 2) {
      return
    }

    reloadPaginationPublish()
    loadPublished(1)
  })

  var watch2 = $scope.$watch('vm.searchExpired', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        reloadPaginationArchived()
        loadArchived(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.searchExpired.length < 2) {
      return
    }

    reloadPaginationArchived()
    loadArchived(1)
  })

  $scope.$on('$destroy', function () {
    watch()
    watch1()
    watch2()
  })
}
